module.exports = __webpack_public_path__ + "static/media/pink-button.c45a166a.png";